import React, { useState } from "react"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

import Section from "../../section/section"
import WavesSlider from "./waveslider"

import PlusIcon from "../../.././../../assets/icons/nova/plus-grey.svg"

import { Accordion, AccordionSection, SliderWrapper } from "./rootcauses.styled"

const RootCauses = ({ data }) => {
  const [disabled, setDisabled] = useState(false)
  const [activeCauseIndex, setActiveCauseIndex] = useState(0)

  const disableDuringAnimation = () => {
    setDisabled(true)
    setTimeout(() => {
      setDisabled(false)
    }, 1100)
  }

  const handleAccordionClick = (index) => {
    if (disabled) return
    disableDuringAnimation()
    setActiveCauseIndex(index)
  }

  return (
    <Section>
      <div className="text-center mx-auto mb-8 sm:mb-10 md:mb-20 max-w-[870px]">
        <TextElementNova
          text={data.title}
          element="h2"
          className="Title-20-Super-Normal mb-4 sm:mb-8"
        />
        <TextElementNova text={data.subtitle} className="Body-30-Dia-Normal" />
      </div>
      <div className="flex">
        <Accordion>
          {data.causes.map((cause, index) => (
            <AccordionSection
              key={index}
              className={index === activeCauseIndex ? "expanded" : ""}
            >
              <button onClick={() => handleAccordionClick(index)}>
                <TextElementNova
                  element="span"
                  text={cause.name}
                  className="Body-30-Dia-Strong"
                />
                <PlusIcon />
              </button>
              {activeCauseIndex === index && (
                <div className="accordion-body">
                  <TextElementNova
                    element="span"
                    text={cause.shortDescription}
                    className="Body-20-Dia-Normal"
                  />
                </div>
              )}
            </AccordionSection>
          ))}
        </Accordion>
        <SliderWrapper>
          <WavesSlider
            causes={data.causes}
            activeIndex={activeCauseIndex}
            setActiveIndex={setActiveCauseIndex}
            disabled={disabled}
            setDisabled={setDisabled}
            disableDuringAnimation={disableDuringAnimation}
          />
        </SliderWrapper>
      </div>
    </Section>
  )
}

export default RootCauses
